import React from 'react';

import { createIcon } from '@chakra-ui/react';

export const ArrowRightIcon = createIcon({
  displayName: 'ArrowRightIcon',
  viewBox: '0 0 16 16',
  path: (
    <path
      clipRule="evenodd"
      d="M7.86193 3.52876C7.60158 3.78911 7.60158 4.21122 7.86193 4.47157L10.7239 7.3335H4C3.63181 7.3335 3.33333 7.63197 3.33333 8.00016C3.33333 8.36835 3.63181 8.66683 4 8.66683H10.7239L7.86193 11.5288C7.60158 11.7891 7.60158 12.2112 7.86193 12.4716C8.12228 12.7319 8.54439 12.7319 8.80474 12.4716L12.8047 8.47157C13.0651 8.21122 13.0651 7.78911 12.8047 7.52876L8.80474 3.52876C8.54439 3.26841 8.12228 3.26841 7.86193 3.52876Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  ),
});
